import { X } from 'react-feather';

export const ModalTypes = {
  CUSTOM: 'custom',
  DEFAULT: 'default',
  WITH_HEIGHT_TRANSITIONS: 'with-height-transitions',
};

export const ButtonIds = {
  CLOSE: 'close',
};

export const CloseButton = {
  id: ButtonIds.CLOSE,
  icon: X,
};

export const TransitionDelay = 50;

export const TransitionDuration = 500;

// Buffer for added borders.
export const BUFFER_HEIGHT = 2;

// Class for button to handle keyboard enter event
export const PRIMARY_BUTTON_CLASS = 'primary-btn';

export const ENTER_KEY_EVENT = 'Enter';
